import { render, staticRenderFns } from "./essay_review_button.vue?vue&type=template&id=1801364c&scoped=true&"
import script from "./essay_review_button.vue?vue&type=script&lang=js&"
export * from "./essay_review_button.vue?vue&type=script&lang=js&"
import style0 from "./essay_review_button.vue?vue&type=style&index=0&id=1801364c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1801364c",
  null
  
)

export default component.exports